import { render, staticRenderFns } from "./AnalyticsWelcome.vue?vue&type=template&id=47ad9464&"
import script from "./AnalyticsWelcome.vue?vue&type=script&lang=js&"
export * from "./AnalyticsWelcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports